import { IPlayImageObjectTask } from 'common/modules/ReactShared';
import React, { useEffect, useRef, useState } from 'react';
import DashedPagination from 'students/views/shared/components/DashedPagination';
import { customMediaQuery } from 'students/views/shared/styled';
import styled from 'styled-components';
import ImageObjectItem, { ISelectAnswerPayload } from './ImageObjectItem';
import { IPointOptions } from './types';

interface IProps {
  task: IPlayImageObjectTask;
  onSelectAnswer: (payload: ISelectAnswerPayload) => void;
  onComplete: () => void;
  onSkip: (itemId: number) => void;
}

const PlayImageObjectMainScreen: React.FC<IProps> = ({
  task,
  onSelectAnswer,
  onComplete,
  onSkip
}) => {
  const { items, imageURL, image: imageSize } = task;
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentItem = items[currentIndex];
  const pointsRef = useRef<IPointOptions[]>([]);

  useEffect(() => {
    const paginationContainer = document.querySelector('.dashed-pagination');

    if (paginationContainer) {
      paginationContainer.classList.add('contrast');
    }

    return () => {
      if (paginationContainer) {
        paginationContainer.classList.remove('contrast');
      }
    };
  }, []);

  const handleComplete = () => {
    onComplete();
  };

  const handleNext = () => {
    if (currentIndex + 1 === items.length) {
      handleComplete();
    } else {
      setCurrentIndex((currentIndex) => currentIndex + 1);
    }
  };

  const handleSelectAnswer = (payload: ISelectAnswerPayload) => {
    onSelectAnswer(payload);

    pointsRef.current.push({
      top: currentItem.top + currentItem.height / 2,
      left: currentItem.left + currentItem.width / 2
    });

    handleNext();
  };

  const handleItemNext = () => {
    onSkip(currentItem.id);

    handleNext();
  };

  const handleItemPrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((currentIndex) => currentIndex - 1);
    }
  };

  return (
    <>
      <ImageObjectItem
        currentIndex={currentIndex}
        item={items[currentIndex]}
        points={pointsRef.current}
        onSelectAnswer={handleSelectAnswer}
        imageURL={imageURL}
        imageSize={imageSize}
      />

      <SPaginationWrapper>
        <DashedPagination
          itemsNumber={items.length}
          currentIndex={currentIndex}
          taskId={task.id}
          onNextItem={handleItemNext}
          onPrevItem={handleItemPrev}
        />
      </SPaginationWrapper>
    </>
  );
};

export default PlayImageObjectMainScreen;

const SPaginationWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 12px 16px;

  ${customMediaQuery('tablet')} {
    position: relative;
    padding: 0;
    display: flex;
    justify-content: center;
  }
`;
